import { Icon } from '@iconify/react';
import { Box, Collapse, Divider, Grid, Tooltip, Typography } from '@mui/material';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import { GridActionsCellItem } from '@mui/x-data-grid';
import PlaceIcon from '@mui/icons-material/Place';
import constants from '../../../../../utils/constants';
import './GeofenceSummary.scss';
import CustomViewCard from './CustomViewCard';

const GeofenceSummary = ({
  handleExpandClick,
  expanded,
  closeCardIcon,
  cardData,
  handleViewEye,
  handleViewVehicle,
  geofenceLoading,
  geofenceMappingList,
  pageNo,
  pageSize,
  count,
  handlePagination,
  setViewEye,
  viewEye
}: any) => {
  const columns = [
    { field: 'vehicleNumber', headerName: 'Vehicle Number', width: 150 },
    { field: 'status', headerName: 'Status', width: 110 },
    { field: 'timeStamp', headerName: 'Date & Time', width: 200 },
    {
      field: 'Location',
      headerName: 'Location',
      width: 110,
      type: 'actions',
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={(<PlaceIcon sx={{ color: '#3239ea' }} />) as any}
          showInMenu={false}
          label='View'
          onClick={e => {
            handleViewVehicle(params);
            e.stopPropagation();
          }}
        />
      ]
    }
  ];
  return (
    <Box className='geofence-accordin'>
      <Box className='geofence-accord'>
        <Box className='icon-accordin' onClick={handleExpandClick}>
          <Icon icon={expanded ? 'icon-park-outline:down' : 'icon-park-outline:up'} />
        </Box>
        <Typography className='summary-title'>{constants?.GeofenceSummary}</Typography>
      </Box>
      <Collapse in={expanded} unmountOnExit>
        <Box className={`collapse-container ${expanded ? 'expanded' : 'not-expanded'}`}>
          <Box className='geofence-card-closeIcon'>
            <Icon
              icon='mingcute:close-circle-fill'
              className='geofence-iconclose'
              onClick={closeCardIcon}
            />
          </Box>
          <Box
            className={`collapse-content ${
              expanded ? 'content-expand' : 'collapse-not-expand'
            }`}
          >
            <Box className='collapse-title-content'>
              <Box className='vehicle-heading'> {constants?.GeofenceVehicleDetails}</Box>
              <Box className='eye-right'>
                <Tooltip title='Mapped Vehicles' placement='top'>
                  <Icon
                    className='eye-icon-summary'
                    icon={
                      cardData?.vehicleNumber?.length > 0 ? 'mdi:eye' : 'el:eye-close'
                    }
                    onClick={handleViewEye}
                  />
                </Tooltip>
              </Box>
            </Box>
            <Box className='geofence-summary-container'>
              <Grid container>
                <Grid container item lg={12} className='geofence-bottom'>
                  <Grid item lg={6}>
                    <Typography className='geofence-key'>
                      {constants.GeofenceName}
                    </Typography>
                  </Grid>
                  <Grid item lg={6}>
                    <Tooltip placement='bottom' title={cardData?.geofenceName}>
                      <Typography className='geofence-key' noWrap>
                        : {cardData?.geofenceName}
                      </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>

                {cardData?.geoType === 'circular' && (
                  <Grid container item lg={12} className='geofence-bottom'>
                    <Grid item lg={6}>
                      <Typography className='geofence-key'>
                        {constants?.Radius}
                      </Typography>
                    </Grid>
                    <Grid item lg={6}>
                      <Typography className='geofence-key'>
                        : {cardData?.radius}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                <Grid container item lg={12} className='geofence-bottom'>
                  <Grid item lg={6}>
                    <Typography className='geofence-key'>
                      {constants?.Location}
                    </Typography>
                  </Grid>
                  <Grid item lg={6}>
                    <Tooltip
                      placement='bottom'
                      title={cardData?.location}
                      className='geofence-summaryaddress'
                    >
                      <Typography className='geofence-key'>
                        : {cardData?.location}
                      </Typography>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Divider
            className='summary-divider'
            orientation='vertical'
            variant='middle'
            flexItem
          />
          <Box className='geofence-mappingtable'>
            <CustomDataGrid
              geofenceTableHeight={true}
              loading={geofenceLoading}
              rows={geofenceMappingList ? geofenceMappingList : []}
              columns={columns}
              type='logistics'
              pageNo={pageNo}
              pageSize={pageSize}
              pageSizeOptions={[5, 10, 15, 20]}
              rowCount={count}
              paginationModel={{
                page: pageNo ? pageNo - 1 : 0,
                pageSize: pageSize ? pageSize : 5
              }}
              onPaginationModelChange={handlePagination}
            />
          </Box>
        </Box>
      </Collapse>
      {viewEye && (
        <CustomViewCard viewEye={viewEye} setViewEye={setViewEye} cardData={cardData} />
      )}
    </Box>
  );
};

export default GeofenceSummary;
